import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { STORE_NAME, STORE_VERSION } from "../constants";

export const AUTH_STORE_NAME = `${STORE_NAME}_AUTH`;
export interface AuthState {
	/**
	 * The auth token used to verify requests to the server
	 */
	token: string | null;
	/**
	 * Action to set the token
	 */
	setToken: (token: string | null) => void;
	/**
	 * Action to remove the token
	 */
	resetState: () => void;
}

// Due to typescript quirks, this has to all be in one giant object for inference
export const useAuthStore = create<AuthState>()(
	// Allows us to use Redux devtools in the browser
	devtools(
		// Persists the state to the localStorage in the browser
		persist(
			// Wraps Immer around the set function
			immer((set) => ({
				token: null,
				setToken: (token) =>
					// set is a state alteration method from Zustand
					set(
						// state is the previous state, normally this should not be altered,
						// but with Immer, it is the preferred way to do it
						(state) => {
							state.token = token;
						},
						// If true, it will overwrite the entire state with the state from the callback
						false,
						// Used to give a name to the logged action in redux devtools
						"auth/setToken",
					),
				resetState: () =>
					// set is a state alteration method from Zustand
					set(
						// state is the previous state, normally this should not be altered,
						// but with Immer, it is the preferred way to do it
						(state) => {
							state.token = null;
						},
						// If true, it will overwrite the entire state with the state from the callback
						false,
						// Used to give a name to the logged action in redux devtools
						"auth/resetState",
					),
			})),
			// Persist options
			{
				name: AUTH_STORE_NAME,
				version: STORE_VERSION,
			},
		),
		// Devtools options
		{
			name: AUTH_STORE_NAME,
			trace: import.meta.env.DEV,
		},
	),
);
